import { useState, useEffect } from 'react';
import { supabase } from '../lib/supabase';

const FALLBACK = [
  { id: 'fb-ss', cruise_name: 'Sunset Cruise',  cruise_code: 'SS', departure_time: '17:30', end_time: '19:30', reporting_time: '17:00', duration_minutes: 120, is_active: true, sort_order: 1, has_upper_deck: true,  has_middle_deck: true },
  { id: 'fb-sd', cruise_name: 'Sundown Cruise', cruise_code: 'SD', departure_time: '18:00', end_time: '20:00', reporting_time: '17:30', duration_minutes: 120, is_active: true, sort_order: 2, has_upper_deck: true,  has_middle_deck: true },
  { id: 'fb-dc', cruise_name: 'Dinner Cruise',  cruise_code: 'DC', departure_time: '19:30', end_time: '22:30', reporting_time: '19:00', duration_minutes: 180, is_active: true, sort_order: 3, has_upper_deck: false, has_middle_deck: true },
];

let _cache = null;
let _promise = null;

export async function fetchCruiseSettings() {
  if (_cache) return _cache;
  if (_promise) return _promise;
  _promise = supabase
    .from('cruise_settings')
    .select('*')
    .eq('is_active', true)
    .order('sort_order')
    .then(({ data, error }) => {
      _promise = null;
      _cache = (!error && data?.length) ? data : FALLBACK;
      return _cache;
    });
  return _promise;
}

export function invalidateCruiseCache() {
  _cache = null;
  _promise = null;
}

export function getCruiseDecks(setting) {
  const decks = [];
  if (setting?.has_upper_deck) decks.push('Upper Deck');
  if (setting?.has_middle_deck) decks.push('Middle Deck');
  return decks;
}

export function useCruiseSettings() {
  const [settings, setSettings] = useState(_cache || []);
  const [loading, setLoading] = useState(!_cache);

  useEffect(() => {
    let cancelled = false;
    fetchCruiseSettings().then(data => {
      if (!cancelled) { setSettings(data); setLoading(false); }
    });
    return () => { cancelled = true; };
  }, []);

  return { settings, loading };
}
